import React, { useEffect, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import { config } from '../../../CommonUtilities/CommonUrl/CommonUrls';
import { CommonAxiosGet } from '../../../CommonUtilities/CommonAxios/CommonAxios';
import { FaHandPointRight, FaPrint, } from "react-icons/fa";
import { useSelector } from 'react-redux';
import { ACADEMIC_YEAR, CONTEXT_NAME } from '../../../CommonUtilities/Validations/RegularExpAndVar';
import { useNavigate } from 'react-router-dom';
import { CommonPageHeading } from '../../../CommonUtilities/CommonHeading/CommonPageHeading';
import { Afterprint, ExamCenterDetails, PersonalDetails } from '../Posts/PrintApplication';

export const PaperDetails = (props) => {
    const { postDataLoadLess } = props
    return (<>  <div className='personal-block'>
        <div className="personal-head mt-1">
            <span>Papers Details</span>
        </div>
        
        <div className="personal-row personal-roweducation">
            <div className="table-responsive mb-3" >
                <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-0"
                    style={{ borderCollapse: 'collapse', }} role="presentation">

                    <tbody>
                        <tr>
                            <th>S.No</th>
                            <th>Paper</th>
                            <th>Language 1</th>
                            <th>Question Paper Medium</th>
                            <th>Applied On</th>
                        </tr>
                        {postDataLoadLess?.length > 0 ? postDataLoadLess?.map((data, index) => {
                            const formattedTimestamp = new Date(data?.applied_on).toLocaleString();
                            return (
                                <tr key={index} id={index}>
                                    <td>{index + 1}.</td>
                                    <td >{data?.tet_paper_name}</td>
                                    <td >{data?.medium}</td>
                                    <td>{data?.qp_medium}</td>
                                    <td >{formattedTimestamp}</td>
                                </tr>
                            )
                        }) :
                            <tr><td colSpan={4} className='text-center'><b className='text-danger'> *** You have not selected any Papers</b></td></tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>

    </div></>)
}
export default function TetPrintApplication() {
    const tabdetails = useSelector((state) => state.reducers.loginreducer.tabdetails);
    const navigate = useNavigate();
    const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails.loginData);
    let componentRef = useRef();
    const handleprint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "DSC- Application Print",
        pageStyle: `
        @media print {
            body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
                font-size: 12px;
            }
            table {
                width: 100% !important;
                table-layout: fixed !important;
                border-collapse: collapse !important;
                page-break-inside: avoid;
                margin-bottom: 15px !important;
            }
            th, td {
                padding: 6px !important;
                border: 1px solid #ddd !important;
                word-wrap: break-word;
                vertical-align: top;
            }
            th {
                background-color: #f2f2f2 !important;
                font-weight: bold;
                }
                  .personal-head span {
                  background-color: #ececec !important;
                  color: #000 !important;
                    }
                  .personal-block{
                    page-break-inside: avoid;
                  }
            .personal-head {
               
                padding: 8px !important;
                margin-top: 15px !important;
                margin-bottom: 10px !important;
                font-weight: bold;
            }
            img {
                max-width: 130px !important;
                max-height: 150px !important;
               
                margin: 0 auto !important;
            }
            .photo-cell {
                width: 150px !important;
                text-align: center !important;
                vertical-align: middle !important;
            }
        }
    `
    });
    const [showData, setData] = useState([])
    const [postDataLoadLess, setPostDataLoadLess] = useState([])
    const getpostDataLaodLessFunction = () => {
        let villUrl = config.url.DSC_URL + "tet-candidate-eligible-papers";
        CommonAxiosGet(villUrl).then((response) => {
            if (response?.data?.status === true) {
                let data = response?.data?.candidateposts;
                setPostDataLoadLess(data?.filter((val) => val?.is_applied === true));
            }
            else {
                setPostDataLoadLess([])
            }
        });
    };

    const [examCenterData, setExamCenterData] = useState([])
    const getExamDataFunction = () => {
        let villUrl = config.url.DSC_URL + "candidate-exam-center-details";
        CommonAxiosGet(villUrl).then((response) => {
            if (response?.data.status === true) {
                setExamCenterData(response.data.data)
            }
            else {
                setExamCenterData([])
            }
        });
    };
    function getStudyData() {
        let Url = config.url.DSC_URL + "candidate-study-details"
        CommonAxiosGet(Url).then((res) => {
            if (res?.data?.status === true) {
                if (res?.data?.candidatereg_status === true) {
                    setData(res?.data?.candidatereg[0])
                }
            }
        })
    }
    useEffect(() => {
        getStudyData()
        getExamDataFunction()
        getpostDataLaodLessFunction()
    }, [])

    /*******************Header*****************************************/

    useEffect(() => {
        const handleKeyDown = (event) => {
            if ((event.ctrlKey || event.metaKey) && (event.key === 'p' || event.key === 'P')) {
                event.preventDefault();
                alert('Print function is disabled on this page.Use print button', 'warning')
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    return (
        <React.Fragment>
            <CommonPageHeading heading='Tet Application Status' />
            {tabdetails?.latestTab === 4 || postDataLoadLess?.length > 0 ?
                <React.Fragment>
                    {postDataLoadLess?.length > 0 ?
                        <div className='mt-4'><h5>
                            <b > Click Here </b> <FaHandPointRight size={30} />&nbsp;
                            <button className="btn btn-primary" variant="primary" onClick={handleprint}>Print&nbsp;
                                <FaPrint title="Print" style={{ fontSize: '22px' }} />
                            </button>
                        </h5></div> : <><div className="text-center mt-4"></div></>}
                    <div ref={componentRef} className='mt-1'>
                        <Afterprint />
                        <PersonalDetails showData={showData} />
                        <PaperDetails postDataLoadLess={postDataLoadLess} />
                        <ExamCenterDetails examCenterData={examCenterData} />
                    </div>
                </React.Fragment>
                : <React.Fragment>
                    <br />
                    <h3 className="text-error mt-4 border p-3 fs-6 w-100">
                        <strong>Dear {loginreducer?.applicant_name},</strong><pre />
                        Your Application is Partially Submitted for {CONTEXT_NAME}-{ACADEMIC_YEAR} , Please Complete the Application to View Print.
                        <span>  <i style={{ background: "#2a9d8f" }}
                            className="badge badge-success forgot fw-bold"
                            onClick={() => navigate('/ProfileDetailsWay')}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    navigate('/ProfileDetailsWay')
                                }
                            }}
                            data-toggle="tooltip" animation="true"
                        > Click Here </i> </span> to complete the application.
                    </h3>
                </React.Fragment>
            }
        </React.Fragment>
    )
}
